import { ART } from "../assets";
import { Reveal } from "./Reveal";

const promises = [
  { title: "Donation first", desc: "We find a second home before a landfill, every time." },
  { title: "Licensed & insured", desc: "Fully covered crews you can trust in your home." },
  { title: "Transparent pricing", desc: "The price you see is the price you pay." },
  { title: "Modern booking", desc: "Book from a photo in minutes — no phone tag." },
  { title: "No hidden fees", desc: "No fuel charges, no surprises at the door." },
  { title: "Friendly crew", desc: "Kind, careful people who treat your space well." },
];

export default function Trust() {
  return (
    <section className="py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="order-2 lg:col-span-5 lg:order-1">
            <Reveal>
              <div className="overflow-hidden rounded-[2.5rem] bg-white/50">
                <img src={ART.trustCrew} alt="A friendly milla crew" className="w-full" />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-2 flex justify-center">
                <img
                  src={ART.trustDonation}
                  alt="Donation complete — your donation, their fresh start"
                  className="w-full max-w-sm"
                />
              </div>
            </Reveal>
          </div>

          <div className="order-1 lg:col-span-7 lg:order-2 lg:pl-8">
            <Reveal>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">Why milla</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl text-balance">
                Care you can feel, from photo to pickup.
              </h2>
            </Reveal>

            <div className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2">
              {promises.map((p, i) => (
                <Reveal key={p.title} delay={i * 0.05}>
                  <div className="border-t border-stone/70 pt-5">
                    <p className="font-display text-xl text-charcoal">{p.title}</p>
                    <p className="mt-2 text-charcoal/55">{p.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
